var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSharePoint(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#8BB8BB",
    d: "M11.396 14.25a7.125 7.125 0 1 0 0-14.25 7.125 7.125 0 0 0 0 14.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B1D0D1",
    d: "M18.052 19.5a6.094 6.094 0 1 0 0-12.188 6.094 6.094 0 0 0 0 12.188Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D8E7E8",
    d: "M12.145 24a4.875 4.875 0 1 0 0-9.75 4.875 4.875 0 0 0 0 9.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3D898D",
    d: "M12.646 5.25H4.52a7.13 7.13 0 0 0 7.493 8.973l.004.028A4.875 4.875 0 0 0 7.285 19.5h5.36a1.003 1.003 0 0 0 1-1V6.25a1.003 1.003 0 0 0-1-1Z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M1.145 6h10a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1h-10a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3D898D",
    d: "M4.398 11.869a1.985 1.985 0 0 1-.616-.653 1.77 1.77 0 0 1-.216-.892c-.013-.422.13-.833.4-1.156a2.356 2.356 0 0 1 1.062-.693c.468-.154.958-.23 1.451-.225a5.516 5.516 0 0 1 1.912.268v1.35a2.99 2.99 0 0 0-.865-.354 4.197 4.197 0 0 0-1.011-.121 2.195 2.195 0 0 0-1.04.22.682.682 0 0 0-.412.624.633.633 0 0 0 .175.443c.135.14.294.254.47.336.197.098.491.228.882.39.044.013.086.03.127.05.386.151.758.335 1.112.55.269.165.494.392.658.661.169.306.25.65.238 1a1.86 1.86 0 0 1-.374 1.203c-.261.318-.61.551-1.002.672a4.538 4.538 0 0 1-1.426.208 7.522 7.522 0 0 1-1.292-.107 4.434 4.434 0 0 1-1.05-.303v-1.426c.322.23.681.4 1.062.506.379.118.772.181 1.169.188a2.01 2.01 0 0 0 1.06-.225.71.71 0 0 0 .356-.636.678.678 0 0 0-.2-.486 2.03 2.03 0 0 0-.551-.384 17.646 17.646 0 0 0-1.04-.465 5.896 5.896 0 0 1-1.039-.543Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h24.194v24H0z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSharePoint);
export default __webpack_public_path__ + "static/media/SharePoint.316d4259f3e70b119cf662552e454b34.svg";
export { ForwardRef as ReactComponent };